// extracted by mini-css-extract-plugin
export default {"navbar":"style_navbar__gm9PL","prev":"style_prev__AusMQ","next":"style_next__0-Nr6","main":"style_main__f-fGa","wb":"style_wb__LB+Mw"};